// ***** This file is for fixed config, will not changed even if user select different options ***** //

import { DataType } from '../../../../constants/DataType'

const { STR, STR_WITHOUT_LIKE, DATETIME, DATE, BOOL, INT, FLOAT } = DataType
export const operator = ln_t => ({
  Equal: { value: 'Equal', label: ln_t('criteria.logics.equal'), component: 'input' },
  NotEqual: { value: 'NotEqual', label: ln_t('criteria.logics.notEqual'), component: 'input' },
  In: { value: 'In', label: ln_t('criteria.logics.include'), component: 'select', multiple: true },
  NotIn: { value: 'NotIn', label: ln_t('criteria.logics.notInclude'), component: 'select', multiple: true },
  Like: { value: 'Like', label: ln_t('criteria.logics.like'), component: 'select' },
  NotLike: { value: 'NotLike', label: ln_t('criteria.logics.notLike'), component: 'select' },
  Interval: { value: 'Interval', label: ln_t('criteria.logics.interval'), component: 'rangepicker' },
  Gt: { value: 'Gt', label: '>=', component: 'inputnumber', precision: 0 },
  Lt: { value: 'Lt', label: '<=', component: 'inputnumber', precision: 0 },
  EqualInt: { value: 'Equal', label: '=', component: 'inputnumber', precision: 0 }
})

// ----- DataType X Operator for logic in criteria ----- //
export const operatorConf = ln_t => {
  const { Equal, NotEqual, In, NotIn, Like, NotLike, Interval, Gt, Lt, EqualInt } = operator(ln_t)
  return {
    [STR]: [Equal, NotEqual, In, NotIn, Like, NotLike],
    [STR_WITHOUT_LIKE]: [Equal, NotEqual, In, NotIn],
    [DATETIME]: [{ ...Equal, component: 'datepicker', time: true }, { ...NotEqual, component: 'datepicker', time: true }, { ...Interval, time: true }],
    [DATE]: [{ ...Equal, component: 'datepicker' }, { ...NotEqual, component: 'datepicker' }, { ...Interval }],
    [BOOL]: [{ ...Equal, component: 'select' }],
    [INT]: [Gt, Lt, EqualInt],
    [FLOAT]: [Gt, Lt, EqualInt]
  }
}
export const multipleOptions = ['In', 'NotIn']

// ----- Aggregate Setting ----- //
export const aggregateLogic = ln_t => [
  { value: 'SUM', label: ln_t('criteria.aggregate.sum') },
  { value: 'AVG', label: ln_t('criteria.aggregate.avg') }
]
export const aggregateValue = [
  { value: '5', label: '5%' },
  { value: '10', label: '10%' },
  { value: '25', label: '25%' },
  { value: '50', label: '50%' }
]
